import { onMounted, onBeforeUnmount, ref } from 'vue'

/** Observe viewport changes; never resize the WebView or change form values. */
export function useKeyboardViewport() {
  const keyboardOpen = ref(false)
  let closedHeight = 0
  let orientation = ''
  const update = () => {
    const viewport = window.visualViewport
    if (!viewport) return
    const currentOrientation = screen.orientation?.type || (window.screen.width > window.screen.height ? 'landscape' : 'portrait')
    const focused = document.activeElement
    const editing = focused instanceof HTMLElement && (focused.matches('input:not([type="checkbox"]):not([type="radio"]):not([readonly]), textarea, [contenteditable="true"]'))
    if (!closedHeight || orientation !== currentOrientation) {
      orientation = currentOrientation
      closedHeight = viewport.height
    }
    if (!editing) closedHeight = Math.max(closedHeight, viewport.height)
    keyboardOpen.value = editing && closedHeight - viewport.height > 120
    if (!editing && viewport.height >= closedHeight - 80) closedHeight = viewport.height
    document.documentElement.classList.toggle('keyboard-open', keyboardOpen.value)
    document.documentElement.style.setProperty('--app-viewport-height', `${viewport.height}px`)
    const keyboardOffset = keyboardOpen.value ? Math.max(0, window.innerHeight - viewport.height - viewport.offsetTop) : 0
    document.documentElement.style.setProperty('--app-keyboard-offset', `${keyboardOffset}px`)
  }
  onMounted(() => {
    update()
    window.visualViewport?.addEventListener('resize', update)
    window.addEventListener('orientationchange', update)
    document.addEventListener('focusin', update)
    document.addEventListener('focusout', update)
  })
  onBeforeUnmount(() => {
    window.visualViewport?.removeEventListener('resize', update)
    window.removeEventListener('orientationchange', update)
    document.removeEventListener('focusin', update)
    document.removeEventListener('focusout', update)
    document.documentElement.classList.remove('keyboard-open')
    document.documentElement.style.removeProperty('--app-viewport-height')
    document.documentElement.style.removeProperty('--app-keyboard-offset')
  })
  return { keyboardOpen }
}
